import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ProductCard } from '../shared/ProductCard';

import { VendorProduct, useGetVendorCustomQuery, useListVendorShowProductsQuery } from '../../lib/api';

const useStyles = makeStyles(theme => ({
    headerText: {
        color: theme.palette.voxi.textPrimaryColor,
        fontFamily: theme.fonts.PAGE_TITLE_TEXT.fontFamily,
        fontWeight: theme.fonts.PAGE_TITLE_TEXT.fontWeight,
        fontStyle: theme.fonts.PAGE_TITLE_TEXT.fontStyle,
        display: "flex",
        justifyContent: "center"        
    }
}));

export function Vendor(props: CategoryProps) {
    const classes = useStyles();

    const queryArgs = { id: props.match.params.vendorID };
    const vendor = useGetVendorCustomQuery(queryArgs);

    const productsQueryArgs = { vendorID: props.match.params.vendorID, showID: props.showID };
    const vendorProducts = useListVendorShowProductsQuery<Array<VendorProduct>>(productsQueryArgs, {
        enabled: !!props.showID,
        select: (response) => { return response.listVendorShowProducts?.items ?? [] }
    });

    return (
        <Grid item container spacing={2} direction="column">
            <Grid item>
                <Typography className={classes.headerText} variant="h4">{`${vendor?.data?.getVendor?.name || ''}`}</Typography>
            </Grid>
            <Grid item container spacing={2}>
                {
                    vendorProducts.data?.map(vendorProduct => {
                        return (
                            <Grid item container key={vendorProduct.productID} xs={12} sm={12} md={6} lg={6} justify="center">
                                <ProductCard product={vendorProduct.product} />
                            </Grid>
                        )
                    })
                }
            </Grid>
        </Grid>
    )
}

interface CategoryProps {
    showID: number
    match: { params: { vendorID } }
}